// Libs
import React, { useState, useContext, useEffect, useRef } from "react";
import { useObserver, KeyValuePair, FieldType, Else, EditableInput, TypographyX } from "@shoothill/core";
import SignaturePad from "react-signature-pad-wrapper";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { FormLabel, Box, Typography, Checkbox, FormControlLabel, Radio, FormControl, Select, InputAdornment, TextField, Grid, Button } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";

// App
import { StoresContext, Stores } from "Globals/Stores";

// Models
import { HomeOwnerStatusEnum } from "Globals/Models/HomeOwnerStatusEnum";

// ViewModels
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";
import ApplicantViewModel from "Globals/ViewModels/ApplicantViewModel";

// Views
import { FileUploader } from "Globals/Views/FileUploader";

// Styles
import { theme } from "Globals/Styles/AppTheme";
import { Row } from "Globals/Styles/LayoutStyles";
import { UserFile } from "Globals/Models/UserFile";
import SupportingInformationViewModel from "Globals/ViewModels/FormSections/SupportingInformation/SupportingInformationViewModel";
import { uniqueId } from "lodash-es";

const StyledUl = styled.ul`
    margin-left: 30px;
    li {
        color: ${theme.palette.hightownBlue.main};
        line-height: 28px;
    }
    li span {
        color: ${theme.palette.common.black};
    }
`;

interface IProps {
    applicant: ApplicantViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const SupportingInformationView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [parentViewModel] = useState(props.applicant.parentSupportingInformationViewModel);
    const [supportViewModel] = useState(new SupportingInformationViewModel(props.applicant.parentSupportingInformationViewModel));

    React.useEffect(() => {
        props.applicationFormViewModel.applicantViewModels.find((vm) => vm.parentSupportingInformationViewModel.setValue("reportsRequired", true));
    }, []);

    return useObserver(() => (
        <div onKeyUp={() => parentViewModel.restartTimer()}>
            {parentViewModel.DevTool_ShowCanProceed && <h5 style={{ color: "red" }}>Can Proceed: {parentViewModel.canProceed ? "Yes" : "No"}</h5>}
            <Row>
                <Typography variant={"h4"} style={{ fontWeight: "bold" }}>
                    What we need from you once you have been offered a property...
                </Typography>
            </Row>

            <Grid container spacing={8}>
                <Grid item lg={6}>
                    <StyledUl>
                        <Typography
                            variant={"body2"}
                            dangerouslySetInnerHTML={{ __html: parentViewModel.getEditableCopyByRouteAndPlaceholderNumber("/supporting-information", 2) }}
                        ></Typography>
                    </StyledUl>

                    <StyledUl>
                        <Typography
                            variant={"body2"}
                            dangerouslySetInnerHTML={{ __html: parentViewModel.getEditableCopyByRouteAndPlaceholderNumber("/supporting-information", 3) }}
                        ></Typography>
                    </StyledUl>
                </Grid>

                <Grid item lg={6}>
                    <StyledUl>
                        <Typography
                            variant={"body2"}
                            dangerouslySetInnerHTML={{ __html: parentViewModel.getEditableCopyByRouteAndPlaceholderNumber("/supporting-information", 4) }}
                        ></Typography>
                    </StyledUl>
                </Grid>
            </Grid>

            <Row>
                <FileUploader
                    key={uniqueId()}
                    showDocType
                    files={parentViewModel.getUserFiles}
                    text={"Upload your supporting information"}
                    onUpload={async (userFile: UserFile) => {
                        parentViewModel.handleInputChange();
                        await supportViewModel.save(userFile, parentViewModel, false);
                    }}
                    onDelete={async (userFile: UserFile) => {
                        let vm = parentViewModel.supportingInformationViewModels.find((vm) => vm.model.documentUrl == userFile.fileUrl);
                        if (vm) {
                            await vm.save(userFile, parentViewModel, true);
                        }
                        parentViewModel.handleInputChange();
                    }}
                    disabled={false}
                    singleFile={false}
                    onDocTypeChange={async (index: number, val: string) => {
                        parentViewModel.handleDocTypeChange(index, val);
                        await supportViewModel.save(parentViewModel.getUserFiles[index], parentViewModel, false, true);
                    }}
                />
            </Row>
        </div>
    ));
};
